export default `
    <div class="container" v-if="current == 'login'">
        <div class="trueleafgs"><a :href="ajax_var.trueleaf_iframe_url"><img :src="ajax_var.base_uri + '/assets/images/logo-gstrueleaf-lg.png'" /></a></div>
        <div class="row justify-content-center">
            <div class="col-md-12">
                <h1 v-html="pages[current].topTitle"></h1>
                <h3>{{ pages[current].fieldLabel }}</h3>
                <form id="loginForm" @submit.prevent="next">
                    <div class="input-container">
                        <div v-if="errorMessage" v-html="errorMessage" class="alert alert-danger" role="alert"></div>
                        
                        <div class="subsMainInput subsMainInput_login_login">
                            <label class="form-label" for="email">Email</label>
                            <input id="login_email" autocomplete="new-password" :disabled="loading" :value="(userData[current] && userData[current].email) ? userData[current].email : ''" name="email" class="dataInput" type="text" />
                        </div>
                        <div class="subsMainInput subsMainInput_login_password">
                            <label class="form-label" for="password">Password</label>
                            <input id="login_password" autocomplete="new-password" :disabled="loading" class="passwordInput" :value="(userData[current] && userData[current].password) ? userData[current].password : ''" name="password" type="password" />
                            <i @click="togglePassword" class="far fa-eye fa-eye-slash" id="togglePassword"></i>
                        </div>
                        <div class="bottom-link"><router-link to="/forgot" class="subs-forgot">Forgot your password?</router-link></div>
                    </div>
                    <div class="subs_form_msge" v-if="pages[current].msge"><input type="checkbox" id="mailing_list_subs" @click="saveZipVal" v-model="mailingListCheck" true-value="1" false-value="false"> <span>{{ pages[current].msge }}</span></div>
                    <div class="form-subs-footer" :class="{ footerEnd: !(window.history && window.history.length > 1) || ajax_var.isPhone }">
                        <a @click="window.history.back()" href="#" v-if="window.history && window.history.length > 1 && !ajax_var.isPhone" class="backBtn">< Back</a>
                        <button :disabled="loading" class="btn btn-1 input-step-btn" type="submit">
                            <span>{{ pages[current].btnLabel }} </span>
                            <i :class="{ hidden: !loading }" role="status" aria-hidden="true" class="fas fa-spinner fa-spin"></i>
                        </button>
                    </div>
                    <div class="bottom-link">Don’t have an account? <router-link :to="registerLink" class="subs-forgot">Signup here. </router-link></div>
                </form>
            </div>
        </div>
    </div>
`;

